import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { LOCAL__ui_g_general__sidebar_field_hovered_set } from '@/state/ui/generation/LOCAL__ui_g_general__sidebar_field_hovered_set';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_HOOK__output__field_hovered_set({ field }: PROPS) {
  /*
   * STORE
   */

  const dispatch = use_dispatch();

  /*
   * EVENTS
   */
  function onMouseOver() {
    dispatch(LOCAL__ui_g_general__sidebar_field_hovered_set(field));
  }

  function onMouseLeave() {
    dispatch(LOCAL__ui_g_general__sidebar_field_hovered_set());
  }

  return { onMouseOver, onMouseLeave };
}
